export default "__VITE_ASSET__DUgU506e__"